import TosQuestion from "./tos-question";
import FileQuestion from "./file-question";
import DateAgeQuestion from "./date-age-question";
import EmailQuestion from "./email-question";
import LoginQuestion from "./login-question";
import EssayQuestion from "./essay-question";
import ImageQuestion from "./image-question";
import RegionQuestion from "./region-question";
import NumberQuestion from "./number-question";
import SectionQuestion from "./section-question";
import CheckBoxQuestion from "./checkbox-question";
import PasswordQuestion from "./password-question";
import DropDownQuestion from "./drop-down-question";
import SingleLineQuestion from "./single-line-question";
import RadioButtonQuestion from "./radio-button-question";
import AccountEmailQuestion from "./account-email-question";
import LocationQuestion from "./location-question";
import type { VoidFunctionComponent } from "react";
import type { Question, QuestionType } from "@/types";

import useVerificationCode from "@/hooks/useVerificationCode";

type FactoryType = {
  // eslint-disable-next-line no-unused-vars
  [key in QuestionType]: VoidFunctionComponent<{
    question: Question;
  }>;
};

const Factory: Partial<FactoryType> = {
  FileQuestion,
  DateQuestion: DateAgeQuestion,
  EmailQuestion,
  EssayQuestion,
  ImageQuestion,
  NumberQuestion,
  RegionQuestion,
  SectionQuestion,
  DropDownQuestion,
  CheckBoxQuestion,
  SingleLineQuestion,
  RadioButtonQuestion,
  "SignupForm::TosQuestion": TosQuestion,
  "SignupForm::LoginQuestion": LoginQuestion,
  "SignupForm::PasswordQuestion": PasswordQuestion,
  "SignupForm::AccountEmailQuestion": AccountEmailQuestion,
  "Demographics::LocationQuestion": LocationQuestion
};

const QuestionFactory = ({ question }): JSX.Element => {
  const isVerificationCode = useVerificationCode();
  const QuestionComponent = Factory[question.type];

  if (!QuestionComponent) return null;
  if (
    isVerificationCode &&
    (question.type === "SignupForm::AccountEmailQuestion" ||
      question.type === "SignupForm::LoginQuestion")
  ) {
    return null;
  }
  return <QuestionComponent question={question} />;
};

export default QuestionFactory;
